import { Component, Input } from '@angular/core';
import { LetteraDiffida } from '../../../models/lettera-diffida';

@Component({
    selector: '[lettera_diffida_entity_view]',
  templateUrl: 'lettera-diffida-entity-view.component.html',
})

export class LetteraDiffidaEntityViewComponent {
  @Input()
  element: LetteraDiffida;
}
